import styled from 'styled-components';
import { Badge, Typography } from 'antd';


export const StyledProjectModeSelectorContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
  gap: 40px;
`;

export const StyledProjectModeSelectorTitle = styled(Typography.Title)<{ $bold?: boolean; }>`
  && {
    font-family: Inter, sans-serif;
    text-align: center;
    margin: 0;
    font-weight: ${({ $bold }) => ($bold ? 800 : 400)};
  }
`;

export const StyledProjectModeSelectorText = styled(Typography.Text)`
  font-family: Inter, sans-serif;
  text-align: center;
  margin-bottom: 24px;
  font-size: 14px;
`;

export const StyledProjectModeSelectorRibbon = styled(Badge.Ribbon)`
  margin-top: -8px;
`;
